// extracted by mini-css-extract-plugin
export default {"share-button-container":"OhJd_","share-button":"Ik8kt","sms":"Wcmey"};